module.exports = __webpack_public_path__ + "img/vertical_7_3_2.acba9377.png";